import React from 'react';
import comingsoon from "../../src/assets/soon.jpg";
import { Bell } from 'lucide-react';

export default function ComingSoon() {
  return (
    <div className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {/* Background Image Container */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={comingsoon}
          alt="coming soon background"
          className="w-full h-full object-cover object-center"
          loading="lazy"
          // Responsive sizing for different screen sizes
          sizes="(max-width: 640px) 100vw, (max-width: 768px) 100vw, (max-width: 1024px) 100vw, 100vw"
        />
      </div>

      {/* Dynamic overlay for better text contrast across devices */}
      <div className="absolute inset-0 bg-black/40 sm:bg-black/30 md:bg-black/25 lg:bg-black/20"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-8 sm:py-10 md:py-12 lg:py-16">
        {/* You can add your content here with responsive text sizing */}
        
      </div>
    </div>
  );
}